import React from 'react';
import { Image, StyleSheet, TouchableOpacity, View } from 'react-native';

import Text from '../global/Text';
import FilePicker from './FilePicker';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import { LanguageType } from '../../constants/Languages';
import { withTranslation, WithTranslation } from 'react-i18next';
import QuestionnaireAttachmentButton from './QuestionnaireAttachmentButton';
import SelectedAttachmentTile from './SelectedAttachmentTile';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const FileIcon = require('../../assets/icons/take-file.png');
// eslint-disable-next-line @typescript-eslint/no-var-requires

type AddFileProps = {
  source: any;
  language: LanguageType;
  isValid?: boolean;
  onUploadFile: (props: any) => void;
  onEditFile?: (source: string) => void;
} & WithTranslation;

// Simple placeholder to add and preview photo
// Also functions as a button to activate the camera
export class AddFile extends React.Component<AddFileProps> {
  getFileName = (source: string) => {
    const extractedName = source.split('/').pop()?.split('?')[0] || source;

    try {
      return decodeURIComponent(extractedName);
    } catch (_err) {
      return extractedName;
    }
  };

  handlePressNew = props => {
    this.props.onUploadFile(props);
  };

  handlePressEdit = (source: string) => {
    if (source) {
      this.props.onEditFile(source);
    }
  };

  render() {
    const { source, isValid, t } = this.props;

    return !source ? (
      <FilePicker onComplete={this.handlePressNew} testID="new-file">
        <QuestionnaireAttachmentButton
          accessibilityLabel={t('questionnaire:addFile')}
          iconSource={FileIcon.default}
          invalid={isValid === false}
          label={t('questionnaire:addFile')}
        />
      </FilePicker>
    ) : (
      <SelectedAttachmentTile
        actionAccessibilityLabel={t('questionnaire:prompt.editDocument')}
        fileName={this.getFileName(source)}
        kind="document"
        onActionPress={() => this.handlePressEdit(source)}
        testID={'edit-file'}
      />
    );
  }
}

const Touchable: any = TouchableOpacity;

const styles = StyleSheet.create({
  portraitBox: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 80,
    height: (62 / 3) * 4 + 4,
    marginVertical: 10,
    marginHorizontal: 2,
    borderRadius: 5,
    borderWidth: 2,
    borderColor: '#efeeed',
    backgroundColor: '#efeeed'
  },
  portraitBoxVideo: {
    height: (62 / 3) * 1 + 4,
    marginVertical: 3,
    marginHorizontal: 2,
    borderRadius: 5,
    borderWidth: 2,
    borderColor: '#FFFF',
    backgroundColor: '#FFFF'
  },
  landscapeBox: {
    justifyContent: 'center',
    alignItems: 'center',
    width: (150 / 3) * 4 + 4,
    height: 80,
    marginVertical: 10,
    marginHorizontal: 2,
    borderRadius: 5,
    borderWidth: 2,
    borderColor: '#efeeed',
    backgroundColor: '#efeeed'
  },
  subtitle: {
    textAlign: 'center',
    fontSize: 14,
    lineHeight: 18
  },
  videoOverlay: {
    position: 'absolute',
    borderRadius: 2,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    // backgroundColor: '#000',
    opacity: 0.5
  },
  playButtonContainer: {
    position: 'absolute',
    borderRadius: 2,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
    zIndex: 10
  },
  playButtonIcon: {
    width: '100%',
    height: '100%',
    overflow: 'visible'
  },
  invalid: {
    borderColor: '#ff6f00'
  },
  photo: {
    flex: 1,
    width: '100%',
    borderRadius: 2
  },
  innerBox: {
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  errorText: {
    marginTop: 5,
    fontSize: 12,
    lineHeight: 12.5,
    textAlign: 'center',
    color: '#FA6161'
  },
  progressText: {
    marginTop: 5,
    fontSize: 12,
    lineHeight: 12.5,
    textAlign: 'center',
    color: '#3cd070'
  }
});

export default withTranslation(['questionnaire'])(AddFile);
